import { render, staticRenderFns } from "./MandateItem.vue?vue&type=template&id=577d9871&scoped=true&"
import script from "./MandateItem.vue?vue&type=script&lang=js&"
export * from "./MandateItem.vue?vue&type=script&lang=js&"
import style0 from "./MandateItem.vue?vue&type=style&index=0&id=577d9871&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d9871",
  null
  
)

export default component.exports